import { Grid, Stack, Typography } from "@mui/material";

interface Props {
  title: string;
  attributes: [string, string][];
}

const FileAttributesSection = ({ title, attributes }: Props) => (
  <Stack spacing={2}>
    <Typography variant="subtitle2">{title}</Typography>
    {attributes.length === 0 ? (
      <Typography color="textSecondary">No properties yet</Typography>
    ) : (
      attributes
        .filter(([, value]) => Boolean(value))
        .map(([attribute, value]) => (
          <Grid container key={attribute} spacing={1}>
            <Grid size={4}>
              <Typography color="textSecondary">{attribute}</Typography>
            </Grid>
            <Grid size={8}>
              <Typography>{value}</Typography>
            </Grid>
          </Grid>
        ))
    )}
  </Stack>
);

export default FileAttributesSection;
